export default (fetch) => {
  return {
    async fetchDoc(collection_id) {
      const { data } = await fetch.get('/arcopen/user/open-doc/view?id=' + collection_id)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('获取文档失败')
      }
    },
    async searchApi(api, code) {
      const { data } = await fetch.get(`/error-mapping/search/api?api=${api}&code=${code}`)
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('获取失败')
      }
    }
  }
}
